export const customButtonStyle = {
    padding: '0.25rem',
    height: '1.5rem',
    minWidth: '2.5rem',
    fontSize: '10px',
    '&.Mui-disabled': {
        backgroundColor: 'grey',
    },
};
